import { getV2ApiAuthenticationFactors } from 'src/client/spendesk-api';
import { type GetV2ApiAuthenticationFactorsResponseOK } from 'src/client/spendesk-api-types';
import { logger } from 'src/utils/datadog-log-wrapper';

export type GetUserAuthenticationFactorsInput = {
  companyId: string;
  userId: string;
};

export const getUserAuthenticationFactors = async ({
  userId,
  companyId,
}: GetUserAuthenticationFactorsInput): Promise<
  GetV2ApiAuthenticationFactorsResponseOK['data']
> => {
  logger.debug(
    `Retrieving user authentication factors - company ${companyId} user ${userId}`,
    {
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    },
  );

  const response = await getV2ApiAuthenticationFactors({});

  if (response.statusCode !== 200) {
    logger.error('Failed to retrieve user authentication factors.', {
      error: response.body,
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    });
    throw new Error('Failed to retrieve user authentication factors.');
  }

  return response.body.data;
};
